import { _isTestEnvironment } from '@angular/cdk/platform';

import { HostId } from './host-id.enum';
import { hostPatterns } from './host-patterns';

// primarly used to test funcionality, please use `CURRENT_HOST_ID` as location is unlikely to change

export const getCurrentHostId = (
  givenIsUnitTestEnvironment: boolean = _isTestEnvironment(),
  // eslint-disable-next-line no-restricted-globals
  givenLocation: Location = location
): HostId => {
  const hostPathName = `${givenLocation?.hostname}${givenLocation?.pathname}`;

  const match = hostPatterns.find((pattern: { hostId: HostId; regExp: RegExp[] }) =>
    pattern.regExp.some(regex => regex.test(hostPathName))
  )?.hostId;

  return givenIsUnitTestEnvironment ? HostId.UnitTestEnvironment : (match ?? HostId.Unknown);
};

export const CURRENT_HOST_ID = getCurrentHostId();
